import api from './api';
import { unwrapApiResponse, ApiResponse } from '@/utils/api-response.util';
import {
  CreateExpertPostDto,
  ExpertPostManagementDto,
  ExpertPostOptions,
  ExpertPostsListResponse,
  ExpertPostVisibility,
  UpdateExpertPostDto,
} from '@/types/expert-posts';

interface GetExpertPostsParams {
  page?: number;
  limit?: number;
  isPublished?: boolean;
  visibility?: ExpertPostVisibility;
}

export const expertPostsService = {
  async getPosts(params: GetExpertPostsParams = {}): Promise<ExpertPostsListResponse> {
    const { page = 1, limit = 10, isPublished, visibility } = params;
    const response = await api.get<ApiResponse<ExpertPostManagementDto[]>>('/expert/posts', {
      params: {
        page,
        limit,
        ...(isPublished !== undefined ? { isPublished } : {}),
        ...(visibility !== undefined ? { visibility } : {}),
      },
    });
    return { data: response.data.data, meta: response.data.meta };
  },

  async getOptions(): Promise<ExpertPostOptions> {
    const response = await api.get(`/expert/posts/options`);
    return unwrapApiResponse<ExpertPostOptions>(response);
  },

  async getPost(id: number): Promise<ExpertPostManagementDto> {
    const response = await api.get(`/expert/posts/${id}`);
    return unwrapApiResponse<ExpertPostManagementDto>(response);
  },

  async createPost(data: CreateExpertPostDto): Promise<ExpertPostManagementDto> {
    const response = await api.post(`/expert/posts`, data);
    return unwrapApiResponse<ExpertPostManagementDto>(response);
  },

  async updatePost(id: number, data: UpdateExpertPostDto): Promise<ExpertPostManagementDto> {
    const response = await api.patch(`/expert/posts/${id}`, data);
    return unwrapApiResponse<ExpertPostManagementDto>(response);
  },

  async deletePost(id: number): Promise<void> {
    await api.delete(`/expert/posts/${id}`);
  },
};
